module.exports = __webpack_public_path__ + "static/media/edit_mode.fa468e02.svg";